import React from 'react';
import { SevenSegmentDigit } from '../common/SevenSegmentDisplay';

type Props = {
  weekIndex: number | null;
  className?: string;
};

/**
 * 학기 주차 2자리 7세그먼트 표시
 * — 활성: 검정 채움 / 비활성: 투명 채움 + 회색 테두리
 */
const DashboardSemesterWeekDigit: React.FC<Props> = ({ weekIndex, className }) => {
  const n =
    typeof weekIndex === 'number' && Number.isFinite(weekIndex) && weekIndex > 0
      ? Math.min(99, Math.floor(weekIndex))
      : 0;
  const label = String(n).padStart(2, '0');

  return (
    <div
      className={['cp-dash-weekly-digit', 'cp-dash-7seg', className].filter(Boolean).join(' ')}
      aria-label={n > 0 ? `학기 ${n}주차` : '학기 주차 없음'}
    >
      <SevenSegmentDigit char={label[0]!} />
      <SevenSegmentDigit char={label[1]!} />
    </div>
  );
};

export default DashboardSemesterWeekDigit;
